<!--业务内容管理-->
<template>
  <sys-content-mange :actionType="ACTION_TYPE.business"/>
</template>

<script>
import SysContentMange from '@/epp/sysContentMange/SysContentMange.vue'
import { ACTION_TYPE } from '@/epp/sysContentMange/util/sysContentMangeUtil'

export default {
  name: 'BusContentMangeIndex',
  computed: {},
  components: { SysContentMange },
  data () {
    return {
      ACTION_TYPE
    }
  },
  methods: {},
}
</script>

<style lang="less" scoped>
</style>
